function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { createContext, useContext, useState } from "react";
import { appConfig } from "../../utils/app-config";
import { validateBreadcrumbs } from "../../utils/breadcrumbs";
import { isTruthy } from "../../utils/isTruthy";
import { ActionBar } from "./Frame/ActionBar";
import { Footer } from "./Frame/Footer";
import { Header } from "./Frame/Header";
import { HeaderSticky } from "./Frame/HeaderSticky";
import { Overlays } from "./Frame/Overlays";
import { SEO } from "./Frame/SEO";
export var getMetatags = function getMetatags(metatags) {
  var _title_attributes;
  if (!metatags) {
    return {};
  }
  var title = metatags.filter(isTruthy).filter(function (param) {
    var tag = param.tag,
      attributes = param.attributes;
    return tag === "meta" && (attributes === null || attributes === void 0 ? void 0 : attributes.name) === "title";
  }).pop();
  var links = metatags.filter(isTruthy).filter(function (param) {
    var tag = param.tag;
    return tag === "link";
  });
  var meta = metatags.filter(isTruthy).filter(function (param) {
    var tag = param.tag;
    return tag === "meta";
  });
  return {
    title: title === null || title === void 0 ? void 0 : (_title_attributes = title.attributes) === null || _title_attributes === void 0 ? void 0 : _title_attributes.content,
    links: links.map(function (param) {
      var attributes = param.attributes;
      return {
        rel: (attributes === null || attributes === void 0 ? void 0 : attributes.rel) || "",
        href: (attributes === null || attributes === void 0 ? void 0 : attributes.href) ?
        // no need to apply any domain logic here.
        attributes.href.replace("https://nginx:8080", appConfig().netlifyUrl) : ""
      };
    }),
    meta: meta.map(function (param) {
      var attributes = param.attributes;
      return {
        name: (attributes === null || attributes === void 0 ? void 0 : attributes.name) || (attributes === null || attributes === void 0 ? void 0 : attributes.property) || "",
        content: (attributes === null || attributes === void 0 ? void 0 : attributes.content) ?
        // no need to apply any domain logic here.
        attributes.content.replace("https://nginx:8080", appConfig().netlifyUrl) : ""
      };
    })
  };
};
var FrameContext = /*#__PURE__*/createContext(undefined);
export var FrameProvider = function FrameProvider(param) {
  var children = param.children;
  var _useState = _sliced_to_array(useState({}), 2),
    frameProps = _useState[0],
    setFrameProps = _useState[1];
  return /*#__PURE__*/React.createElement(FrameContext.Provider, {
    value: {
      frameProps: frameProps,
      setFrameProps: setFrameProps
    }
  }, children);
};
var useFrame = function useFrame() {
  var context = useContext(FrameContext);
  if (!context) {
    throw new Error("useFrame must be used within a FrameProvider");
  }
  return context;
};
export var Frame = function Frame(_param) {
  var children = _param.children,
    props = _object_without_properties(_param, ["children"]);
  var setFrameProps = useFrame().setFrameProps;
  React.useEffect(function () {
    setFrameProps(props);
  }, [setFrameProps, JSON.stringify(props)]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, getMetatags(props.metatags)), children);
};
export var FrameRoot = function FrameRoot(param) {
  var children = param.children;
  var frameProps = useFrame().frameProps;
  var _frameProps_hideHeader = frameProps.hideHeader,
    hideHeader = _frameProps_hideHeader === void 0 ? false : _frameProps_hideHeader,
    _frameProps_hideCallToActionInHeader = frameProps.hideCallToActionInHeader,
    hideCallToActionInHeader = _frameProps_hideCallToActionInHeader === void 0 ? false : _frameProps_hideCallToActionInHeader,
    _frameProps_hideEmployerBranding = frameProps.hideEmployerBranding,
    hideEmployerBranding = _frameProps_hideEmployerBranding === void 0 ? false : _frameProps_hideEmployerBranding,
    nodeId = frameProps.nodeId,
    breadcrumbs = frameProps.breadcrumbs;
  var _validateBreadcrumbs;
  return /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, /*#__PURE__*/React.createElement(Overlays, null), /*#__PURE__*/React.createElement(Header, {
    hideHeader: hideHeader,
    hideCallToActionInHeader: hideCallToActionInHeader
  }), /*#__PURE__*/React.createElement(HeaderSticky, {
    breadcrumbs: (_validateBreadcrumbs = validateBreadcrumbs(breadcrumbs)) !== null && _validateBreadcrumbs !== void 0 ? _validateBreadcrumbs : [],
    hideHeader: hideHeader,
    hideCallToActionInHeader: hideCallToActionInHeader
  }), /*#__PURE__*/React.createElement("div", {
    className: "site-content"
  }, /*#__PURE__*/React.createElement("main", {
    id: "main-content",
    role: "main"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, children, !!nodeId && /*#__PURE__*/React.createElement(ActionBar, {
    remoteId: nodeId
  })))), /*#__PURE__*/React.createElement(Footer, {
    hideEmployerBranding: hideEmployerBranding
  }));
};